import { useQuery } from "@tanstack/react-query";
import { api, euro } from "@/lib/api";

const PLACES = { home: "Accueil", product: "Fiches produits", cart: "Panier", checkout: "Paiement", subscription: "Page abonnement", savings: "Article économies" };

/** Objectif : 5 nouveaux abonnements par jour. Chiffres réels uniquement (aucune estimation). */
export function SubPerformance() {
  const { data } = useQuery({ queryKey: ["admin-sub-performance"], queryFn: async () => (await api.get("/admin/subscriptions/performance")).data });
  if (!data) return null;
  const series = Array.isArray(data.series) ? data.series : [];
  const max = Math.max(5, ...series.map((d) => d.duo + d.solo));
  const cells = [
    ["Nouveaux / jour", `${data.per_day}`, `objectif ${data.goal_per_day}`, "perf-per-day"],
    [`Nouveaux (${data.days} j)`, data.new, `Duo ${data.by_plan?.duo ?? 0} · Solo ${data.by_plan?.solo ?? 0}`, "perf-new"],
    ["Revenu mensuel récurrent", euro(data.mrr ?? 0), `${data.active} abonnements actifs`, "perf-mrr"],
    ["Arrêts", data.canceled, `sur ${data.days} jours`, "perf-canceled"],
    ["Gardent au 2e envoi", data.retention_2nd == null ? "—" : `${data.retention_2nd} %`, "rétention", "perf-retention"],
    ["Visiteurs → abonnés", data.visitor_to_sub == null ? "—" : `${data.visitor_to_sub} %`, `${data.visitors} visiteurs`, "perf-conversion"],
  ];
  return (
    <section data-testid="admin-sub-performance" className="mb-8 rounded-sm border border-[var(--gold)]/60 p-4">
      <p className="mb-4 font-semibold text-[var(--gold-soft)]">Performance des abonnements · objectif 5 par jour</p>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-6">
        {cells.map(([label, value, hint, id]) => (
          <div key={id} className="rounded-sm border border-[var(--line)] p-3">
            <p className="text-[11px] uppercase tracking-[0.16em] text-[var(--muted)]">{label}</p>
            <p data-testid={id} className="mt-1 font-display text-2xl">{value}</p>
            <p className="text-xs text-[var(--parchment)]/70">{hint}</p>
          </div>
        ))}
      </div>
      <div data-testid="perf-chart" className="mt-5 flex h-24 items-end gap-[3px]" aria-label="Nouveaux abonnements par jour">
        {series.map((d) => (
          <div key={d.day} title={`${d.day} : Duo ${d.duo} · Solo ${d.solo}`} className="flex flex-1 flex-col justify-end">
            <span className="block bg-[var(--gold)]" style={{ height: `${(d.duo / max) * 96}px` }} />
            <span className="block bg-[var(--parchment)]/50" style={{ height: `${(d.solo / max) * 96}px` }} />
          </div>
        ))}
      </div>
      <p className="mt-1 text-xs text-[var(--parchment)]/70">Or : Duo · gris : Solo · par jour sur {data.days} jours</p>
      <div data-testid="perf-clicks" className="mt-4 flex flex-wrap gap-2 text-sm">
        <span className="text-[var(--muted)]">Clics sur les boutons d'abonnement :</span>
        {Object.entries(data.clicks || {}).length ? Object.entries(data.clicks).map(([k, v]) => (
          <span key={k} className="rounded-full border border-[var(--line)] px-3 py-1">{PLACES[k] || k} · Duo <b>{v.duo}</b> · Solo <b>{v.solo}</b></span>
        )) : <span>aucun pour l'instant (comptés seulement avec l'accord cookies mesure d'audience)</span>}
      </div>
    </section>
  );
}
